var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Slider } from '../../../components/SlideDown';
export class Ipad extends Component {
    constructor() {
        super('Ipad', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('body').hasClass('page-template-ipad')) {
                let isTimeoutSet = false;
                // Reload page after newsletter subscription
                setInterval(() => {
                    if ($('.inf-success').css('display') === 'block' && !isTimeoutSet) {
                        isTimeoutSet = true;
                        setTimeout(() => {
                            location.reload();
                        }, 5000);
                    }
                }, 1000);
                // Reload page after 15 seconds of inactivity
                let inactivityTimeout;
                const resetInactivityTimeout = () => {
                    clearTimeout(inactivityTimeout);
                    inactivityTimeout = window.setTimeout(() => {
                        location.reload();
                    }, 60000);
                };
                $(document).on(['click', 'keypress', 'touchmove'], () => {
                    resetInactivityTimeout();
                });
                let errorFound = false;
                $('.gform_button').on('click', () => {
                    errorFound = false;
                });
                console.log('Start checking newsletter subscription form');
                setInterval(() => {
                    if ($('.gform_confirmation_message').length > 0 && !errorFound) {
                        setTimeout(() => {
                            console.log('Reload page after newsletter subscription');
                            location.reload();
                        }, 5000);
                        errorFound = true;
                    }
                    if ($('.gform_submission_error').length > 0 && !errorFound) {
                        Slider.computeHeight($('.gform_wrapper').parents('.slide-down'));
                        console.error('Error found in newsletter subscription form');
                        errorFound = true;
                    }
                }, 500);
            }
            this.success();
        });
    }
}
